(function () {
  'use strict';

  if (window.customElements.get('lbac-quiz')) return;

  var STEPS = ['intent', 'format', 'color', 'sign'];
  var OPTIONAL = { color: true, sign: true };
  var NEUTRAL = { color: 'any', sign: 'none' };
  var BATCH = 6;
  var MAX_RESULTS = 3;
  var MAX_PRODUCTS = 3;
  var TIMEOUT = 6000;
  var RETURN_KEY = 'lbac-quiz-retour';
  var SECTION = 'lbac-quiz-collection';

  var FORMAT_TYPES = {
    bracelet: ['bracelet', 'bracelet / collier'],
    collier: ['pendentif', 'collier', 'bracelet / collier'],
    bague: ['bague'],
    pierre: ['pierre roulée', 'pierre brute', 'pièce de collection', 'pointes et pyramides']
  };

  var SWATCHES = {
    violet: '#9c7cae', pink: '#e4b4b8', blue: '#7895b6', green: '#89a387',
    orange: '#bd7660', gold: '#c6a15a', black: '#545258', white: '#e7e3df'
  };

  var ICONS = {
    calm: '<path d="M3 8h14a3 3 0 1 0-3-3M3 12h19M3 16h10a3 3 0 1 1-3 3"/>',
    night: '<path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5 8.5 8.5 0 1 0 20.5 14.5Z"/><path d="m18 3 .8 2.2L21 6l-2.2.8L18 9l-.8-2.2L15 6l2.2-.8Z"/>',
    love: '<path d="M12 21S3 15 3 8.5A4.5 4.5 0 0 1 12 7a4.5 4.5 0 0 1 9 1.5C21 15 12 21 12 21Z"/>',
    confidence: '<circle cx="12" cy="12" r="4"/><path d="M12 1v3m0 16v3M1 12h3m16 0h3M4 4l2 2m12 12 2 2M4 20l2-2M18 6l2-2"/>',
    protection: '<path d="M12 2 21 6v5c0 5-5 9-9 11-4-2-9-6-9-11V6Z"/><path d="m8 12 3 3 5-6"/>',
    grounding: '<path d="M20 3C8 2 1 8 5 15s14 6 15-12Z"/><path d="M3 22 16 8"/>',
    abundance: '<path d="m12 2 2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4Z"/>',
    intuition: '<path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12Z"/><circle cx="12" cy="12" r="3"/>',
    bracelet: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="4" r="2"/><circle cx="20" cy="12" r="2"/><circle cx="12" cy="20" r="2"/><circle cx="4" cy="12" r="2"/>',
    collier: '<path d="M4 2c0 8 3 12 8 13 5-1 8-5 8-13M12 15l4 4-4 4-4-4Z"/>',
    bague: '<circle cx="12" cy="15" r="6.5"/><path d="m9.5 5 2.5-3 2.5 3-2.5 3.5Z"/>',
    pierre: '<path d="M5 4 15 2l6 6-1 10-9 4-8-5-1-7Z"/><path d="m5 4 3 7 12 7M8 11l7-9"/>',
    any: '<path d="m12 2 2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4Z"/>'
  };

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return '&#' + c.charCodeAt(0) + ';';
    });
  }

  function fill(template, values) {
    return Object.keys(values).reduce(function (out, key) {
      return out.split('[' + key + ']').join(values[key]);
    }, String(template || ''));
  }

  function icon(name) {
    return '<svg class="lbac-quiz__tile-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + (ICONS[name] || ICONS.any) + '</svg>';
  }

  function normalize(text) {
    return String(text || '').toLowerCase().replace(/œ/g, 'oe').replace(/æ/g, 'ae')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function firstSentence(text) {
    var match = String(text || '').match(/^.*?[.!?](\s|$)/);
    return match ? match[0].trim() : String(text || '');
  }

  function publish(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload || {});
      }
    } catch (e) {}
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function navigationType() {
    try {
      var entry = performance.getEntriesByType('navigation')[0];
      return entry ? entry.type : '';
    } catch (e) {
      return '';
    }
  }

  function blankAnswers() {
    return { intent: null, format: null, color: null, sign: null, budget: null };
  }

  class LbacQuiz extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.quizId = this.dataset.sectionId || 'quiz';
      this.t = JSON.parse(this.querySelector('[data-lbac-quiz-texts]').textContent);
      this.intro = this.querySelector('[data-view="intro"]');
      this.app = this.querySelector('[data-app]');
      this.status = this.querySelector('[data-status]');
      this.root = (this.dataset.root || '/').replace(/\/$/, '');
      this.answers = blankAnswers();
      this.seed = null;
      this.view = 'intro';
      this.step = 0;
      this.editing = false;
      this.cache = new Map();
      this.token = 0;
      this.timers = [];

      this.handleClick = this.handleClick.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handlePop = this.handlePop.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('change', this.handleChange);
      window.addEventListener('popstate', this.handlePop);
      window.addEventListener('resize', this.handleResize);

      this.boot();
    }

    disconnectedCallback() {
      this.ready = false;
      this.token++;
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('change', this.handleChange);
      window.removeEventListener('popstate', this.handlePop);
      window.removeEventListener('resize', this.handleResize);
      clearTimeout(this.advanceTimer);
      this.timers.forEach(clearTimeout);
      this.timers = [];
    }

    boot() {
      var state = history.state;
      var ours = state && state.lbacQuiz === this.quizId;
      if (ours && state.view === 'results' && navigationType() === 'back_forward') {
        var saved = this.readReturn();
        if (saved) {
          this.answers = Object.assign(blankAnswers(), saved.answers);
          this.seed = saved.seed;
          this.loadData().then(() => this.showResults({ push: false, focus: false }), () => this.showIntro({ push: false }));
          return;
        }
      }
      if (navigationType() !== 'back_forward') this.clearReturn();
      this.save('replace', 'intro');
    }

    save(mode, view, step, editing) {
      var entry = { lbacQuiz: this.quizId, view: view, step: step || 0, editing: !!editing };
      try {
        history[mode === 'push' ? 'pushState' : 'replaceState'](Object.assign({}, history.state || {}, entry), '', location.href);
      } catch (e) {}
    }

    loadData() {
      if (!this.dataPromise) {
        this.dataPromise = fetch(this.dataset.dataUrl, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('data_' + response.status);
            return response.json();
          })
          .then((data) => {
            this.applyTexts(data);
            this.data = data;
            return data;
          })
          .catch((error) => {
            this.dataPromise = null;
            throw error;
          });
      }
      return this.dataPromise;
    }

    applyTexts(data) {
      var t = this.t;
      ['intents', 'formats', 'colors', 'signs'].forEach(function (group) {
        var prefix = group.slice(0, -1);
        Object.keys(data[group]).forEach(function (key) {
          if (t[prefix + '_' + key]) data[group][key] = t[prefix + '_' + key];
        });
      });
    }

    handleClick(event) {
      var input = event.target;
      if (input instanceof HTMLInputElement && input.type === 'radio' && STEPS.indexOf(input.name) !== -1) {
        if (event.detail > 0 && this.view === 'step') {
          this.answers[input.name] = input.value;
          this.refreshNav();
          this.autoAdvance(input.name);
        }
        return;
      }
      var edit = event.target.closest('[data-edit]');
      if (edit && this.contains(edit)) {
        event.preventDefault();
        this.editing = true;
        this.goStep(STEPS.indexOf(edit.dataset.edit), { push: true });
        return;
      }
      var link = event.target.closest('[data-position]');
      if (link && this.contains(link)) {
        publish('lbac_quiz_result_click', { position: Number(link.dataset.position) });
        this.writeReturn();
        return;
      }
      var control = event.target.closest('[data-action]');
      if (!control || !this.contains(control)) return;
      event.preventDefault();
      switch (control.dataset.action) {
        case 'start':
          this.start();
          break;
        case 'next':
          this.next();
          break;
        case 'back':
          history.back();
          break;
        case 'retry':
          this.showResults({ push: false, focus: true });
          break;
        case 'restart':
          this.restart();
          break;
      }
    }

    handleChange(event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || STEPS.indexOf(input.name) === -1) return;
      this.answers[input.name] = input.value;
      this.refreshNav();
    }

    handlePop(event) {
      var state = event.state;
      if (!state || state.lbacQuiz !== this.quizId) return;
      this.editing = !!state.editing;
      if (state.view === 'results') {
        if (this.answers.intent && this.answers.format && this.data) this.showResults({ push: false, focus: true });
        else this.showIntro({ push: false });
      } else if (state.view === 'step') {
        if (this.data) this.goStep(state.step, { push: false });
        else this.showIntro({ push: false });
      } else {
        this.showIntro({ push: false, focus: true });
      }
    }

    autoAdvance(key) {
      var token = this.token;
      clearTimeout(this.advanceTimer);
      this.advanceTimer = setTimeout(() => {
        if (token === this.token && this.view === 'step' && STEPS[this.step] === key && this.answers[key]) this.next();
      }, reduceMotion() ? 0 : 220);
    }

    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.placeNav(), 150);
    }

    start() {
      this.clearReturn();
      this.seed = window.LbacQuizEngine.seedValue();
      this.answers = blankAnswers();
      this.editing = false;
      publish('lbac_quiz_start', {});
      this.loadData().then(
        () => this.goStep(0, { push: true }),
        () => this.showLoadError()
      );
    }

    restart() {
      this.clearReturn();
      this.seed = window.LbacQuizEngine.seedValue();
      this.answers = blankAnswers();
      this.editing = false;
      this.goStep(0, { push: true });
    }

    next() {
      var key = STEPS[this.step];
      if (!OPTIONAL[key] && !this.answers[key]) return;
      if (this.editing) {
        this.editing = false;
        history.back();
        return;
      }
      if (this.step === STEPS.length - 1) this.showResults({ push: true, focus: true });
      else this.goStep(this.step + 1, { push: true });
    }

    showIntro(options) {
      this.token++;
      this.view = 'intro';
      this.editing = false;
      this.app.hidden = true;
      this.app.innerHTML = '';
      this.intro.hidden = false;
      this.setStatus('');
      if (options.push) this.save('push', 'intro');
      if (options.focus) this.focusView();
    }

    showLoadError() {
      this.intro.hidden = true;
      this.app.hidden = false;
      this.app.innerHTML = '<div class="lbac-quiz__panel"><p class="lbac-quiz__panel-text">' + esc(this.t.error) + '</p><button type="button" class="lbac-quiz__button" data-action="start">' + esc(this.t.retry) + '</button></div>';
      this.focusView(this.app.querySelector('[data-action="start"]'));
    }

    goStep(index, options) {
      if (index < 0 || index >= STEPS.length) return;
      this.token++;
      this.view = 'step';
      this.step = index;
      this.intro.hidden = true;
      this.app.hidden = false;
      this.app.innerHTML = this.renderStep();
      this.setStatus('');
      if (options.push) this.save('push', 'step', index, this.editing);
      publish('lbac_quiz_step', { step: index + 1 });
      this.focusView();
      this.placeNav();
      this.timers.push(setTimeout(() => this.placeNav(), 1500));
    }

    renderStep() {
      var t = this.t;
      var key = STEPS[this.step];
      var optional = !!OPTIONAL[key];
      var uid = 'LbacQuiz-' + this.quizId;
      var rail = STEPS.map((name, i) => {
        var current = i === this.step;
        var done = !current && (this.answers[name] || i < this.step);
        return '<li class="lbac-quiz__rail-step' + (done ? ' is-done' : '') + '"' + (current ? ' aria-current="step"' : '') + '>' +
          '<span class="lbac-quiz__rail-index" aria-hidden="true">' + (done ? '&#10003;' : i + 1) + '</span>' +
          '<span>' + esc(t['step_' + name]) + '</span></li>';
      }).join('');

      var options = this.options(key);
      var grid = options.main.map((option) => this.tile(key, option)).join('');
      var neutral = options.neutral ? '<div class="lbac-quiz__neutral">' + this.tile(key, options.neutral) + '</div>' : '';

      return '<div class="lbac-quiz__workspace">' +
        '<aside class="lbac-quiz__rail" aria-hidden="true">' +
          '<p class="lbac-quiz__rail-title">' + t.rail_title + '</p>' +
          '<ol class="lbac-quiz__rail-steps">' + rail + '</ol>' +
          '<p class="lbac-quiz__rail-note">' + esc(t.rail_note) + '</p>' +
        '</aside>' +
        '<div class="lbac-quiz__stage">' +
          '<div class="lbac-quiz__stage-head">' +
            '<div class="lbac-quiz__progress-label"><span>' + esc(fill(t.progress, { n: this.step + 1, total: STEPS.length })) + '</span>' +
            '<span>' + esc(optional ? t.tag_optional : t.tag_required) + '</span></div>' +
            '<progress class="lbac-quiz__progress" value="' + (this.step + 1) + '" max="' + STEPS.length + '" aria-hidden="true"></progress>' +
            '<h2 class="lbac-quiz__h2" id="' + uid + '-q" tabindex="-1" data-focus>' + esc(t['q_' + key + '_title']) + '</h2>' +
            '<p class="lbac-quiz__help" id="' + uid + '-help">' + esc(t['q_' + key + '_help']) + '</p>' +
          '</div>' +
          '<fieldset class="lbac-quiz__fieldset" aria-describedby="' + uid + '-help">' +
            '<legend class="lbac-quiz__sr">' + esc(t['q_' + key + '_title']) + '</legend>' +
            '<div class="lbac-quiz__grid lbac-quiz__grid--' + key + '">' + grid + '</div>' + neutral +
          '</fieldset>' +
          '<p class="lbac-quiz__hint" data-hint aria-live="polite"></p>' +
          '<div class="lbac-quiz__nav" data-nav>' +
            '<button type="button" class="lbac-quiz__text-button" data-action="back"><span aria-hidden="true">&larr;</span> <span class="lbac-quiz__back-label">' + esc(t.back) + '</span></button>' +
            '<button type="button" class="lbac-quiz__button lbac-quiz__button--next" data-action="next" data-next></button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    refreshNav() {
      var key = STEPS[this.step];
      var next = this.app.querySelector('[data-next]');
      var hint = this.app.querySelector('[data-hint]');
      if (!next) return;
      var answered = !!this.answers[key];
      var allowed = OPTIONAL[key] || answered;
      var label = this.editing ? this.t.update : this.step === STEPS.length - 1 ? this.t.finish : this.t.next;
      next.innerHTML = esc(label) + '<span class="lbac-quiz__arrow" aria-hidden="true">&rarr;</span>';
      next.disabled = !allowed;
      hint.textContent = answered ? this.t.hint_selected : OPTIONAL[key] ? this.t.hint_optional : this.t.hint_required;
    }

    options(key) {
      var t = this.t;
      var d = this.data;
      if (key === 'intent') {
        return { main: Object.keys(d.intents).map((id) => ({ id: id, label: d.intents[id], detail: t['intent_' + id + '_detail'], icon: id })) };
      }
      if (key === 'format') {
        var ids = Object.keys(d.formats).filter((id) => id !== 'any');
        return {
          main: ids.map((id) => ({ id: id, label: d.formats[id], detail: t['format_' + id + '_detail'], icon: id })),
          neutral: { id: 'any', label: d.formats.any, icon: 'any' }
        };
      }
      if (key === 'color') {
        return {
          main: Object.keys(d.colors).map((id) => ({ id: id, label: d.colors[id], swatch: SWATCHES[id] })),
          neutral: { id: 'any', label: t.color_any, icon: 'any' }
        };
      }
      return {
        main: Object.keys(d.signs).map((id) => ({ id: id, label: d.signs[id], detail: t['sign_' + id + '_dates'] })),
        neutral: { id: 'none', label: t.sign_none, icon: 'any' }
      };
    }

    tile(key, option) {
      var id = 'LbacQuiz-' + this.quizId + '-' + key + '-' + option.id;
      var checked = this.answers[key] === option.id;
      var visual = option.swatch
        ? '<span class="lbac-quiz__swatch" style="background:' + option.swatch + '" aria-hidden="true"></span>'
        : option.icon ? icon(option.icon) : '';
      return '<div class="lbac-quiz__option">' +
        '<input class="lbac-quiz__input" type="radio" id="' + id + '" name="' + key + '" value="' + esc(option.id) + '"' + (checked ? ' checked' : '') + '>' +
        '<label class="lbac-quiz__tile" for="' + id + '">' + visual +
          '<span class="lbac-quiz__tile-text"><span class="lbac-quiz__tile-label">' + esc(option.label) + '</span>' +
          (option.detail ? '<span class="lbac-quiz__tile-detail">' + esc(option.detail) + '</span>' : '') + '</span>' +
          '<span class="lbac-quiz__check" aria-hidden="true"></span>' +
        '</label></div>';
    }

    placeNav() {
      var nav = this.app.querySelector('[data-nav]');
      if (!nav) return;
      var left = 0;
      var right = 0;
      if (window.innerWidth < 700) {
        var host = document.querySelector('shopify-chat');
        var button = host && host.shadowRoot && host.shadowRoot.querySelector('button');
        var box = button && button.getBoundingClientRect();
        if (box && box.width > 0 && box.height > 0 && box.bottom > window.innerHeight - 120) {
          if (box.left + box.width / 2 < window.innerWidth / 2) left = Math.ceil(box.right) + 8;
          else right = Math.ceil(window.innerWidth - box.left) + 8;
        }
      }
      this.style.setProperty('--lbac-quiz-nav-left', left ? left + 'px' : '');
      this.style.setProperty('--lbac-quiz-nav-right', right ? right + 'px' : '');
      this.refreshNav();
    }

    showResults(options) {
      var token = ++this.token;
      var engine = window.LbacQuizEngine;
      this.view = 'results';
      this.editing = false;
      this.intro.hidden = true;
      this.app.hidden = false;
      if (options.push) this.save('push', 'results');

      var ranked;
      try {
        ranked = engine.rank(this.answers, this.data, this.seed);
      } catch (e) {
        this.goStep(0, { push: false });
        return;
      }

      this.app.innerHTML = this.renderResultsHead() + '<div class="lbac-quiz__results" data-results aria-busy="true"><div class="lbac-quiz__placeholder" aria-hidden="true"></div></div>' +
        '<p class="lbac-quiz__end"><button type="button" class="lbac-quiz__text-button" data-action="restart">' + esc(this.t.restart) + '</button></p>';
      this.setStatus(this.t.loading);
      if (options.focus) this.focusView();

      this.pickAvailable(ranked).then((chosen) => this.localize(chosen)).then((chosen) => {
        if (token !== this.token) return;
        this.renderResults(ranked, chosen);
        publish('lbac_quiz_complete', { results: chosen.length });
      }, () => {
        if (token !== this.token) return;
        this.renderError();
      });
    }

    renderResultsHead() {
      var t = this.t;
      var d = this.data;
      var a = this.answers;
      var values = {
        intent: d.intents[a.intent],
        format: d.formats[a.format],
        color: a.color && a.color !== 'any' ? d.colors[a.color] : t.chip_color_any,
        sign: a.sign && a.sign !== 'none' ? d.signs[a.sign] : t.chip_sign_none
      };
      var chips = STEPS.map(function (key) {
        return '<button type="button" class="lbac-quiz__chip" data-edit="' + key + '" aria-label="' + esc(fill(t.edit_label, { step: t['step_' + key].toLowerCase(), value: values[key] })) + '">' +
          esc(values[key]) + ' <span aria-hidden="true">&#8599;</span></button>';
      }).join('');
      return '<header class="lbac-quiz__results-head">' +
        '<p class="lbac-quiz__kicker">' + esc(t.results_kicker) + '</p>' +
        '<h2 class="lbac-quiz__h2 lbac-quiz__h2--results" tabindex="-1" data-focus>' + esc(t.results_title) + '</h2>' +
        '<div class="lbac-quiz__chips">' + chips + '</div>' +
      '</header>';
    }

    pickAvailable(ranked) {
      var engine = window.LbacQuizEngine;
      var format = ranked.answers.format;
      var candidates = ranked.candidates;
      var known = new Map();

      var decide = () => {
        var count = 0;
        for (var i = 0; i < candidates.length; i++) {
          var status = known.get(candidates[i].stone.id);
          if (status === undefined) return null;
          if (status === 'error') throw new Error('network');
          if (status === 'available') count++;
          if (count === MAX_RESULTS) break;
        }
        return engine.pick({ candidates: candidates.filter((c) => known.has(c.stone.id)) }, (c) => known.get(c.stone.id) === 'available', MAX_RESULTS);
      };

      var run = (start) => {
        var batch = candidates.slice(start, start + BATCH);
        if (!batch.length) return Promise.resolve(decide() || []);
        return Promise.all(batch.map((item) => this.fetchCollection(item.destination.handle, '').then((info) => {
          item.info = info;
          item.products = this.productsFor(info, format, item.stone);
          known.set(item.stone.id, item.products.length ? 'available' : 'unavailable');
        }, () => {
          known.set(item.stone.id, 'error');
        }))).then(() => {
          var chosen = decide();
          return chosen ? chosen : run(start + BATCH);
        });
      };

      return run(0);
    }

    localize(chosen) {
      if (!this.root) return chosen;
      var root = this.root;
      var prefixed = function (url) {
        return url && url.indexOf(root + '/') !== 0 ? root + url : url;
      };
      return Promise.all(chosen.map((item) => this.fetchCollection(item.destination.handle, root).then((local) => {
        var byId = new Map((local.products || []).map(function (p) { return [p.id, p]; }));
        item.info = Object.assign({}, item.info, { url: local.url || prefixed(item.info.url) });
        item.products = item.products.map(function (p) {
          var l = byId.get(p.id);
          return l ? Object.assign({}, p, { title: l.title, url: l.url, imageAlt: l.imageAlt, price: l.price }) : Object.assign({}, p, { url: prefixed(p.url) });
        });
      }, () => {
        item.info = Object.assign({}, item.info, { url: prefixed(item.info.url) });
        item.products = item.products.map(function (p) { return Object.assign({}, p, { url: prefixed(p.url) }); });
      }))).then(function () { return chosen; });
    }

    productsFor(info, format, stone) {
      var allowed = FORMAT_TYPES[format];
      var names = [normalize(stone.name), normalize(stone.id)].filter(Boolean).map(function (name) {
        return new RegExp('(^| )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '( |$)');
      });
      return ((info && info.products) || []).filter(function (product) {
        if (allowed && allowed.indexOf(String(product.type || '').trim().toLowerCase()) === -1) return false;
        var title = normalize(product.title);
        return names.some(function (re) { return re.test(title); });
      });
    }

    fetchCollection(handle, prefix) {
      var key = prefix + '|' + handle;
      if (this.cache.has(key)) return this.cache.get(key);
      var controller = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () {
        if (controller) controller.abort();
      }, TIMEOUT);
      var url = prefix + '/collections/' + encodeURIComponent(handle) + '?section_id=' + SECTION;
      var promise = fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
        .then(function (response) {
          if (response.status === 404) return { products: [], missing: true };
          if (!response.ok) throw new Error('http_' + response.status);
          return response.text().then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var node = doc.querySelector('[data-lbac-quiz-collection]');
            if (!node) throw new Error('parse');
            return JSON.parse(node.textContent);
          });
        })
        .finally(function () {
          clearTimeout(timer);
        });
      this.cache.set(key, promise);
      promise.catch(() => this.cache.delete(key));
      return promise;
    }

    renderResults(ranked, chosen) {
      var box = this.app.querySelector('[data-results]');
      if (!box) return;
      box.removeAttribute('aria-busy');
      this.setStatus('');
      if (!chosen.length) {
        box.innerHTML = '<div class="lbac-quiz__panel"><p class="lbac-quiz__panel-text">' + esc(this.t.empty) + '</p>' +
          '<button type="button" class="lbac-quiz__button" data-edit="format">' + esc(this.t.empty_button) + '</button></div>';
        this.setStatus(this.t.empty);
        return;
      }
      var a = ranked.answers;
      var notice = a.color !== 'any' && !chosen.some(function (c) { return c.colorMatch; })
        ? '<p class="lbac-quiz__notice">' + esc(this.t.color_unavailable) + '</p>' : '';
      var html = notice + this.renderMain(chosen[0], a);
      if (chosen.length > 1) {
        html += '<div class="lbac-quiz__alts"><p class="lbac-quiz__alts-title">' + esc(this.t.alts_title) + '</p><div class="lbac-quiz__alts-grid">' +
          chosen.slice(1).map((item, i) => this.renderAlt(item, a, i + 2)).join('') + '</div></div>';
      }
      box.innerHTML = html;
    }

    media(item, size, eager) {
      var info = item.info || {};
      var src = size === 'small' ? info.imageSmall : info.image;
      if (!src) return '<div class="lbac-quiz__frame" aria-hidden="true"><span>' + esc(item.stone.name) + '</span></div>';
      var width = size === 'small' ? 240 : 720;
      return '<img class="lbac-quiz__media-img" src="' + esc(src) + '" alt="" width="' + width + '" height="' + width + '"' + (eager ? '' : ' loading="lazy"') + '>';
    }

    renderMain(item, a) {
      var t = this.t;
      var stone = item.stone;
      var name = stone.name.toLocaleLowerCase('fr');
      var reasons = window.LbacQuizEngine.reasons(item, a, this.data, {
        intent: t.reason_intent, formatAny: t.reason_format_any, format: t.reason_format, color: t.reason_color, sign: t.reason_sign
      });
      var products = item.products.slice(0, MAX_PRODUCTS).map(function (p) {
        var price = p.from ? fill(t.price_from, { price: p.price }) : p.price;
        return '<li class="lbac-quiz__product"><a href="' + esc(p.url) + '" data-position="1">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.imageAlt) + '" width="300" height="300" loading="lazy">' : '<span class="lbac-quiz__frame lbac-quiz__frame--product" aria-hidden="true"></span>') +
          '<span class="lbac-quiz__product-title">' + esc(p.title) + '</span>' +
          '<span class="lbac-quiz__product-price">' + esc(price) + '</span></a></li>';
      }).join('');
      var url = (item.info && item.info.url) || this.root + '/collections/' + item.destination.handle;
      return '<article class="lbac-quiz__main">' +
        '<div class="lbac-quiz__main-media">' + this.media(item, 'large', true) + '</div>' +
        '<div class="lbac-quiz__main-body">' +
          '<h3 class="lbac-quiz__h3 lbac-quiz__main-name">' + esc(stone.name) + '</h3>' +
          '<p class="lbac-quiz__description">' + esc(stone.description) + '</p>' +
          '<div class="lbac-quiz__why"><p class="lbac-quiz__why-title">' + esc(t.why_title) + '</p><ul>' +
            reasons.map(function (r) { return '<li><span aria-hidden="true">&#10003;</span><span>' + esc(r) + '</span></li>'; }).join('') +
          '</ul></div>' +
          (products ? '<div class="lbac-quiz__products"><p class="lbac-quiz__products-title">' + esc(t.products_title) + '</p><ul>' + products + '</ul></div>' : '') +
          '<a class="lbac-quiz__button lbac-quiz__button--block" href="' + esc(url) + '" data-position="1">' + esc(fill(t['cta_' + a.format], { pierre: name })) +
          '<span class="lbac-quiz__arrow" aria-hidden="true">&rarr;</span></a>' +
        '</div>' +
      '</article>';
    }

    renderAlt(item, a, position) {
      var name = item.stone.name.toLocaleLowerCase('fr');
      var url = (item.info && item.info.url) || this.root + '/collections/' + item.destination.handle;
      return '<article class="lbac-quiz__alt">' +
        '<div class="lbac-quiz__alt-media">' + this.media(item, 'small', false) + '</div>' +
        '<div class="lbac-quiz__alt-body"><h3 class="lbac-quiz__h3">' + esc(item.stone.name) + '</h3>' +
        '<p>' + esc(firstSentence(item.stone.description)) + '</p>' +
        '<a class="lbac-quiz__alt-link" href="' + esc(url) + '" data-position="' + position + '">' + esc(fill(this.t['alt_' + a.format], { pierre: name })) + ' <span aria-hidden="true">&rarr;</span></a></div>' +
      '</article>';
    }

    renderError() {
      var box = this.app.querySelector('[data-results]');
      if (!box) return;
      box.removeAttribute('aria-busy');
      box.innerHTML = '<div class="lbac-quiz__panel"><p class="lbac-quiz__panel-text">' + esc(this.t.error) + '</p>' +
        '<button type="button" class="lbac-quiz__button" data-action="retry">' + esc(this.t.retry) + '</button></div>';
      this.setStatus(this.t.error);
    }

    setStatus(text) {
      if (this.status) this.status.textContent = text || '';
    }

    focusView(target) {
      var node = target || (this.view === 'intro' ? this.intro : this.app).querySelector('[data-focus]');
      if (node) {
        try {
          node.focus({ preventScroll: true });
        } catch (e) {
          node.focus();
        }
      }
      var box = this.getBoundingClientRect();
      var offset = this.headerOffset();
      if (box.top < offset || box.top > window.innerHeight * 0.4) {
        window.scrollTo({ top: window.pageYOffset + box.top - offset, behavior: reduceMotion() ? 'auto' : 'smooth' });
      }
    }

    headerOffset() {
      var header = document.querySelector('.shopify-section-header-sticky, .section-header.shopify-section-header-sticky, sticky-header');
      if (!header) return 12;
      var box = header.getBoundingClientRect();
      return box.bottom > 0 && box.top <= 0 ? Math.ceil(box.bottom) + 12 : 12;
    }

    writeReturn() {
      try {
        sessionStorage.setItem(RETURN_KEY, JSON.stringify({ answers: this.answers, seed: this.seed }));
      } catch (e) {}
    }

    readReturn() {
      try {
        var saved = JSON.parse(sessionStorage.getItem(RETURN_KEY) || 'null');
        return saved && saved.answers && saved.answers.intent && saved.answers.format ? saved : null;
      } catch (e) {
        return null;
      }
    }

    clearReturn() {
      try {
        sessionStorage.removeItem(RETURN_KEY);
      } catch (e) {}
    }
  }

  window.customElements.define('lbac-quiz', LbacQuiz);
})();
